<div class="custom-report-page">

  <!-- ── Top toolbar ─────────────────────────────────────────────────────── -->
  <div class="report-toolbar">
    <div class="toolbar-left">
      <h5 class="toolbar-title">
        Client Financial Analysis
      </h5>
    </div>

    <div class="view-toolbar-actions d-flex align-items-center" style="gap: 12px;">
      <!-- Export Excel (Official System Style) -->
      <button class="btn btn-sm d-flex align-items-center gap-1"
        style="background-color: #217346; color: white; box-shadow: none !important; border: none; white-space: nowrap; border-radius: 8px; font-size: 13px; padding: 5px 12px;"
        (click)="exportExcel()" [disabled]="!hasRun || exporting" title="Export current report as Excel">
        <i class="fa fa-file-excel-o"></i>
        <span>{{ exporting ? 'Exporting...' : 'Export Excel' }}</span>
      </button>

      <!-- Action Group -->
      <div class="view-switcher rounded-lg" role="group">
        <!-- Clear All -->
        <button type="button" class="view-switcher__btn" (click)="clearFilters()"
          [disabled]="!selectedMonthYears.length || loading || exporting" title="Clear Filters">
          <i class="fa fa-eraser"></i><span>Clear</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ── Main layout ──────────────────────────────────────────────────────── -->
  <div class="report-layout">

    <!-- LEFT PANEL: Filter controls ──────────────────────────────────────── -->
    <aside class="columns-panel">
      <!-- Run button at top -->
      <div class="panel-run-btn">
        <button class="btn-run" (click)="runReport()" [disabled]="!selectedMonthYears.length || loading || exporting">
          <i data-feather="play"></i>
          {{ loading ? 'Loading...' : 'Run Report' }}
        </button>
      </div>

      <!-- Filters List -->
      <div class="filter-section">
        <!-- Months Selector -->
        <div class="filter-item-group">
          <label class="filter-label">Months <span class="required">*</span></label>
          <app-month-year-multi-select id="fa-month-filter" (selectionChange)="onMonthSelectionChange($event)">
          </app-month-year-multi-select>
        </div>

        <!-- Salesperson -->
        <div class="filter-item-group">
          <label class="filter-label">Salesperson</label>
          <app-select-autocomplete id="fa-salesperson-filter" [source]="salespeople" [control]="salespersonControl"
            valueField="uid" labelField="name" placeholder="All salespeople">
          </app-select-autocomplete>
        </div>

        <!-- City -->
        <div class="filter-item-group">
          <label class="filter-label">City</label>
          <app-select id="fa-city-filter" [source]="cities" valueField="name" labelField="name" placeholder="All cities"
            [control]="cityControl">
          </app-select>
        </div>

        <!-- Zone -->
        <div class="filter-item-group">
          <label class="filter-label">Zone</label>
          <app-select id="fa-zone-filter" [source]="zones" valueField="name" labelField="name" placeholder="All zones"
            [control]="zoneControl">
          </app-select>
        </div>

        <!-- ZIP Code -->
        <div class="filter-item-group">
          <label class="filter-label">ZIP Code</label>
          <input id="fa-zip-filter" type="text" class="filter-input" placeholder="e.g. 33101" [(ngModel)]="zipFilter"
            maxlength="10">
        </div>
      </div>
    </aside>

    <!-- RIGHT: Grid area ──────────────────────────────────────────────────── -->
    <div class="grid-area">

      <!-- Empty state -->
      <div class="empty-state" *ngIf="!hasRun && !loading && !exporting">
        <div class="empty-icon">
          <i data-feather="bar-chart-2"></i>
        </div>
        <h6>Client Financial Analysis</h6>
        <p>Select the months and filters you need from the left panel,<br>then click <strong>Run Report</strong>.</p>
        <button class="btn-run-empty" (click)="runReport()" [disabled]="!selectedMonthYears.length">
          <i data-feather="play"></i> Run Report
        </button>
      </div>

      <!-- Loading -->
      <div class="loading-state" *ngIf="loading || exporting">
        <div class="spinner"></div>
        <span>{{ exporting ? 'Exporting data to Excel...' : 'Generating report...' }}</span>
      </div>

      <!-- Grid wrapper -->
      <div class="grid-wrapper" *ngIf="hasRun && !loading && !exporting">
        <!-- Summary Totals Grid (Kite Design System Style) -->
        <div class="kpi-grid">

          <div class="kpi-card">
            <div class="kpi-icon">
              <i class="fa fa-tint"></i>
            </div>
            <div class="kpi-body">
              <div class="kpi-value">{{ totalGross | number:'1.2-2' }}</div>
              <div class="kpi-label">Gross Collected (gal)</div>
            </div>
          </div>

          <div class="kpi-card">
            <div class="kpi-icon accent-green">
              <i class="fa fa-check-circle"></i>
            </div>
            <div class="kpi-body">
              <div class="kpi-value">{{ totalClean | number:'1.2-2' }}</div>
              <div class="kpi-label">Clean Oil (gal)</div>
            </div>
          </div>

          <div class="kpi-card">
            <div class="kpi-icon accent-red">
              <i class="fa fa-trash"></i>
            </div>
            <div class="kpi-body">
              <div class="kpi-value">{{ totalWaste | number:'1.2-2' }}</div>
              <div class="kpi-label">Waste (gal)</div>
            </div>
          </div>

          <div class="kpi-card">
            <div class="kpi-icon accent-yellow">
              <i class="fa fa-usd"></i>
            </div>
            <div class="kpi-body">
              <div class="kpi-value">{{ totalPayout | currency }}</div>
              <div class="kpi-label">Total Payout</div>
            </div>
          </div>

        </div>

        <app-kite-grid
          [columnDefs]="columnDefs"
          [rowData]="gridData"
          [totalRecords]="totalRecords"
          [pageSize]="gridData.length || 1">
        </app-kite-grid>

      </div>

    </div>
  </div>

</div>